import Vue from "vue";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  adapter: {
    loaded({ _, el }) {
      el.parentElement.classList.remove("animate-pulse");
    },
    loading(listener, _) {
      listener.el.parentElement.classList.add("animate-pulse");
    }
  }
});
